import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { device } from '../../../sharpr/device/device.js';

export function ColumnarStoryBoardRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.ColumnarStoryBoard', {
		url: '/board/columnar/:boardHash',
		controllerAs: 'vm',
		controller: ColumnarStoryBoardCtrl,
		templateUrl: '/ng/hub/StoryBoard/Columnar/StoryBoardColumnarCtrl.html?' + window.BUILD,
		resolve: {
			$style: () => AssetManager.css('/ng/hub/StoryBoard/Columnar/StoryBoardColumnarCtrl.css'),
			$title: () => 'Storyboard',
		},
	});
}

export class ColumnarStoryBoardCtrl {
	constructor($timeout, $scope, Api, modal, $stateParams, Theme) {
		'ngInject';
		this.$timeout = $timeout;
		this.$scope = $scope;
		this.Api = Api;
		this.modal = modal;
		this.Theme = Theme;
		this.boardHash = $stateParams.boardHash;
		this.maybeMobileStyling = {};
		this.requestBoard();
	}

	setupPhone() {
		const centerPosts = () => {
			this.$timeout(() => {
				const margin = 18;
				const postWidth = 260;
				const winWidth = window.innerWidth;
				const numPostsAcross = Math.max(1, Math.floor(winWidth / (postWidth + margin + margin)));
				const newWidth = numPostsAcross * (postWidth + margin) - margin;
				const newMargin = Math.max(18, Math.floor((winWidth - newWidth) / 2));
				this.maybeMobileStyling = {
					marginLeft: `${newMargin}px`,
				};
			});
		};
		window.addEventListener('resize', centerPosts);
		this.$scope.$on('$destroy', () => {
			window.removeEventListener('resize', centerPosts);
		});
		centerPosts();
	}

	/**
	 * Make request to get board. If the board is password protected, prompt for password and send again.
	 * @param {Object} [params={}]  GET params to be sent in the URL. E.g., `{password: '332rjsafle'}`
	 */
	requestBoard(params = {}) {
		const baseEndpoint = `/v2/story_boards/${this.boardHash}`;
		const headers = this.boardHash.startsWith('p') ? null : { Authorization: 'Public' };
		this.Api.request('get', baseEndpoint, params, headers).then(resp => {
			if (resp.status == 403) {
				const options = {
					heading: 'Password required',
					text: 'Please enter the password to continue',
					confirmText: 'Continue',
					cancelText: 'Exit',
					isPassword: true,
					attemptFocus: true,
				};
				this.modal.prompt(options).then(
					password => {
						this.requestBoard({ password });
					},
					() => {
						window.location.href = window.BASE_URL + '/login';
					}
				);
			} else if (resp.status == 404) {
				this.boardNotFound = true;
			} else {
				this.setup(resp.data);
			}
		});
	}

	setup(data) {
		if (data.posts && data.posts.length === 0) {
			this.noPostsFound = true;
		}
		this.storyBoard = data;
		this.Theme.apply(this.storyBoard.theme);
		if (device.isPhone()) {
			this.setupPhone();
		}
	}
}
